import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import setRemInit from './plugins/setRem' ///rem
import router from './router/index'
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.prototype.$EventBus = new Vue()
Vue.use(Vant)
Vue.config.productionTip = false
setRemInit()
new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
